export const GET_PROPERTY_TYPE_BREAKDOWN = 'GET_PROPERTY_TYPE_BREAKDOWN';
export const GET_PROPERTY_TYPE_BREAKDOWN_SUCCESS = 'GET_PROPERTY_TYPE_BREAKDOWN_SUCCESS';
export const GET_PROPERTY_TYPE_BREAKDOWN_FAILURE = 'GET_PROPERTY_TYPE_BREAKDOWN_FAILURE';

export const GET_SECURITIES_STATUS_BREAKDOWN = 'GET_SECURITIES_STATUS_BREAKDOWN';
export const GET_SECURITIES_STATUS_BREAKDOWN_SUCCESS = 'GET_SECURITIES_STATUS_BREAKDOWN_SUCCESS';
export const GET_SECURITIES_STATUS_BREAKDOWN_FAILURE = 'GET_SECURITIES_STATUS_BREAKDOWN_FAILURE';

export const GET_LOAN_STATUS_BREAKDOWN = 'GET_LOAN_STATUS_BREAKDOWN';
export const GET_LOAN_STATUS_BREAKDOWN_SUCCESS = 'GET_LOAN_STATUS_BREAKDOWN_SUCCESS';
export const GET_LOAN_STATUS_BREAKDOWN_FAILURE = 'GET_LOAN_STATUS_BREAKDOWN_FAILURE';

export const GET_CLOSING_DATE_BREAKDOWN = 'GET_CLOSING_DATE_BREAKDOWN';
export const GET_CLOSING_DATE_BREAKDOWN_SUCCESS = 'GET_CLOSING_DATE_BREAKDOWN_SUCCESS';
export const GET_CLOSING_DATE_BREAKDOWN_FAILURE = 'GET_CLOSING_DATE_BREAKDOWN_FAILURE';

export const GET_LOANS_SUMMARY = 'GET_LOANS_SUMMARY';
export const GET_LOANS_SUMMARY_SUCCESS = 'GET_LOANS_SUMMARY_SUCCESS';
export const GET_LOANS_SUMMARY_FAILURE = 'GET_LOANS_SUMMARY_FAILURE';

export const GET_CASHFLOW_PER_MONTH_BREAKDOWN = 'GET_CASHFLOW_PER_MONTH_BREAKDOWN';
export const GET_CASHFLOW_PER_MONTH_BREAKDOWN_SUCCESS = 'GET_CASHFLOW_PER_MONTH_BREAKDOWN_SUCCESS';
export const GET_CASHFLOW_PER_MONTH_BREAKDOWN_FAILURE = 'GET_CASHFLOW_PER_MONTH_BREAKDOWN_FAILURE';

export const GET_DASHBOARD_SUMMARY_TOTALS = 'GET_DASHBOARD_SUMMARY_TOTALS';
export const GET_DASHBOARD_SUMMARY_TOTALS_SUCCESS = 'GET_DASHBOARD_SUMMARY_TOTALS_SUCCESS';
export const GET_DASHBOARD_SUMMARY_TOTALS_FAILURE = 'GET_DASHBOARD_SUMMARY_TOTALS_FAILURE';